export const css = {
    root: '_2sQCvHx4',
    pressed: 'q5sKhj1n',
    disabled: '_3WMm_gxJ',
    label: '_1IS8xL00',
    ' _key': 'apic-theme/apic/dojo/button'
};
export default css;
